export default __webpack_public_path__ + "static/media/learning-support.960e4a4f.png";